import { useState, useEffect } from 'react';
import { VIDEO } from 'Constants/General';
import { s3 } from 'Services/AWS/s3';

const useLesson = ({ selectedLesson }) => {
  const [contentUrl, setContentUrl] = useState(null);

  useEffect(() => {
    // Si no hay archivo no se hace nada.
    if (!selectedLesson?.file) return;

    // El backend coordinó forzar el Content-Type solo para video.
    const contentType = selectedLesson?.LessonType?.name === VIDEO ? 'video/mp4' : undefined;

    // Si hay un archivo generamos una URL firmada para poder visualizarlo.
    s3.getSignedUrl(selectedLesson?.file, contentType).then(data => {
      setContentUrl(data?.signedUrl ?? '');
    });
  }, [selectedLesson]);

  return {
    contentUrl,
  };
};

export default useLesson;
